"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DateOrTime;
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _moment = _interopRequireDefault(require("moment"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Pretty a date/time value to show time for today or a date otherwise wrapped in a tooltip */
function DateOrTime({
  children,
  tooltipProps,
  ...rest
}) {
  if (!children) return null;
  const date = (0, _moment.default)(children);
  const today = (0, _moment.default)();
  const yesterday = (0, _moment.default)().subtract(1, 'day');
  const isToday = date.isSame(today, 'day');
  const isYesterday = date.isSame(yesterday, 'day');
  const display = isToday ? date.format('h:mm a') : isYesterday ? 'Yesterday' : date.format('MM/DD/YY');
  const tooltip = isToday ? `Today at ${date.format('h:mm a')}` : isYesterday ? `Yesterday at ${date.format('h:mm a')}` : date.format('MM/DD/YY h:mm a');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    title: tooltip,
    ...tooltipProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      ...rest,
      children: display
    })
  });
}